import { useState } from "react";
import { Get, Set } from "../../../../Request";
import { useSelector, useDispatch } from "react-redux";

export const useClup = () => {
  const [Data, setData] = useState({
    loading: true,
    data: null,
  });
  const getclup = data => {
    Get({
      url: "/clup",
    }).then(response => {
      setData({
        loading: false,
        data: response,
      });
    });
  };
  const buyoffer = async data => {
    return await Get({
      url: "/buyoff",
      data: {
        ...data,
      },
      stat: true,
    }).then(data => {
      return data;
    });
  };
  return { getclup, Data, buyoffer };
};
